<div class="ui-g-12 ui-lg-12 text-right" style="float:unset;">
    <button pButton type="button"
            class="k-generic-btn"
            icon="fa fa-angle-left"
            iconPos="left"
            (click)="onCustomButton()"
            label="{{ 'common.back' | translate }}"></button>
</div>

<app-kontable
        id="dt_user_companies"
        title="{{ 'companyApplications.sectionTitle' | translate }}"
        [columns]="['applicationName', 'app_icon', 'msBaseUrl']"
        [titles]="['companyApplications.applicationName', 'companyApplications.app_icon', 'companyApplications.msBaseUrl']"
        [source]="selectedApplicationsClone"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [showGlobalFilter]="false"
        [showInfoButton]="false"
        [konPermissions]="perm"
        [(fireNewDataAvailable)]="newDataAvailable"
        (onAdd)="showDialog($event)"
        (onEdit)="showDialog($event)">
</app-kontable>

<p-dialog
        *ngIf="showInfoModal"
        [(visible)]="showInfoModal"
        [modal]="true"
        header="{{modalTitle}}"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
    <app-company-applications-form
            (companyApplicationAdded)="companyApplicationsAdded($event)"
            (companyApplicationUpdated)="companyApplicationsUpdated($event)"
            [dialogBoxCompanyApplications]="companyApplication"
            *ngIf="showInfoModal">
    </app-company-applications-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/company/applications/companyApplications.component.html